export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const categories = [
  {
    key: "shoes",
    link: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20with%20crisp%20laces%20on%20a%20soft%20sage%20green%20studio%20backdrop%20with%20gentle%20daylight%20and%20soft%20shadows%2C%20minimalist%20editorial%20product%20photography%2C%20high%20detail%2C%20fresh%20calm%20aesthetic&width=700&height=700&seq=cat-shoes-2&orientation=squarish&nocache=true",
  },
  {
    key: "hoodies",
    link: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20heathered%20oatmeal%20hoodie%20draped%20on%20a%20wooden%20hanger%20against%20a%20warm%20terracotta%20rust%20studio%20wall%20with%20soft%20natural%20light%2C%20editorial%20streetwear%20product%20photo%2C%20high%20detail%2C%20warm%20earth%20tone%20aesthetic&width=700&height=700&seq=cat-hoodies-2&orientation=squarish&nocache=true",
  },
  {
    key: "tshirts",
    link: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20plain%20cotton%20t-shirt%20in%20soft%20cream%20folded%20neatly%20on%20a%20pale%20peach%20studio%20surface%20with%20gentle%20side%20light%20and%20soft%20shadows%2C%20minimalist%20editorial%20fashion%20photo%2C%20high%20detail%2C%20warm%20airy%20aesthetic&width=700&height=700&seq=cat-tshirts-2&orientation=squarish&nocache=true",
  },
  {
    key: "jackets",
    link: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20on%20a%20wooden%20hanger%20against%20a%20warm%20sand%20beige%20studio%20backdrop%20with%20soft%20window%20light%20and%20gentle%20shadows%2C%20editorial%20fashion%20product%20photo%2C%20high%20detail%2C%20neutral%20earthy%20aesthetic&width=700&height=700&seq=cat-jackets-2&orientation=squarish&nocache=true",
  },
  {
    key: "pants",
    link: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Pair%20of%20casual%20khaki%20chino%20trousers%20folded%20neatly%20on%20a%20light%20olive%20studio%20surface%20with%20soft%20natural%20light%20and%20subtle%20shadows%2C%20minimalist%20editorial%20fashion%20photo%2C%20high%20detail%2C%20calm%20sage%20aesthetic&width=700&height=700&seq=cat-pants-2&orientation=squarish&nocache=true",
  },
  {
    key: "headwear",
    link: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Stylish%20cream%20baseball%20cap%20placed%20on%20a%20soft%20blush%20pink%20studio%20surface%20with%20gentle%20natural%20light%20and%20soft%20shadows%2C%20editorial%20streetwear%20product%20photo%2C%20high%20detail%2C%20soft%20pastel%20aesthetic&width=700&height=700&seq=cat-headwear-2&orientation=squarish&nocache=true",
  },
  {
    key: "sets",
    link: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Matching%20coordinated%20outfit%20set%20of%20a%20top%20and%20trousers%20displayed%20together%20beside%20a%20small%20eucalyptus%20plant%20on%20a%20warm%20cream%20studio%20surface%20with%20soft%20light%2C%20editorial%20fashion%20photo%2C%20high%20detail%2C%20organic%20minimal%20aesthetic&width=700&height=700&seq=cat-sets-2&orientation=squarish&nocache=true",
  },
  {
    key: "underwear",
    link: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20premium%20cotton%20underwear%20garments%20on%20a%20powder%20pink%20studio%20surface%20with%20soft%20diffused%20light%20and%20gentle%20shadows%2C%20clean%20minimal%20editorial%20product%20photo%2C%20high%20detail%2C%20soft%20feminine%20aesthetic&width=700&height=700&seq=cat-underwear-2&orientation=squarish&nocache=true",
  },
  {
    key: "jersey",
    link: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Sporty%20athletic%20jersey%20shirt%20on%20a%20wooden%20hanger%20against%20a%20light%20mint%20green%20studio%20backdrop%20with%20soft%20natural%20light%20and%20gentle%20shadows%2C%20editorial%20sportswear%20product%20photo%2C%20high%20detail%2C%20fresh%20clean%20aesthetic&width=700&height=700&seq=cat-jersey-2&orientation=squarish&nocache=true",
  },
  {
    key: "accessories",
    link: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20wristwatch%20and%20classic%20sunglasses%20arranged%20on%20a%20warm%20beige%20stone%20surface%20with%20soft%20natural%20light%20and%20gentle%20shadows%2C%20editorial%20accessory%20product%20photo%2C%20high%20detail%2C%20timeless%20warm%20aesthetic&width=700&height=700&seq=cat-accessories-2&orientation=squarish&nocache=true",
  },
  {
    key: "bags",
    link: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Premium%20camel%20brown%20leather%20handbag%20placed%20on%20a%20soft%20taupe%20studio%20surface%20with%20gentle%20window%20light%20and%20soft%20shadows%2C%20editorial%20luxury%20product%20photo%2C%20high%20detail%2C%20warm%20minimal%20aesthetic&width=700&height=700&seq=cat-bags-2&orientation=squarish&nocache=true",
  },
  {
    key: "belts",
    link: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20with%20brass%20buckle%20neatly%20coiled%20on%20a%20caramel%20leather%20backdrop%20with%20soft%20natural%20light%20and%20gentle%20shadows%2C%20editorial%20product%20photo%2C%20high%20detail%2C%20rich%20warm%20aesthetic&width=700&height=700&seq=cat-belts-2&orientation=squarish&nocache=true",
  },
  {
    key: "perfumes",
    link: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20placed%20on%20a%20soft%20rose%20studio%20surface%20with%20gentle%20natural%20light%20and%20soft%20shadows%2C%20editorial%20luxury%20beauty%20photo%2C%20high%20detail%2C%20romantic%20warm%20aesthetic&width=700&height=700&seq=cat-perfumes-2&orientation=squarish&nocache=true",
  },
  {
    key: "other",
    link: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Small%20curated%20collection%20of%20everyday%20accessories%20and%20lifestyle%20items%20arranged%20on%20a%20light%20ecru%20studio%20surface%20with%20soft%20diffused%20light%2C%20editorial%20flat%20lay%20photo%2C%20high%20detail%2C%20clean%20neutral%20aesthetic&width=700&height=700&seq=cat-other-2&orientation=squarish&nocache=true",
  },
];